import {createFileRoute} from '@tanstack/react-router'

import AwarenessScreen from '@protected/awareness'

export const Route = createFileRoute('/_protected/awareness')({component: AwarenessScreen})
